<template>
  <section class="footer-menu">
    <div v-if="screenWidth < 992" class="footer-menu__header" @click="open = !open">
      {{ result?.title }}
      <svg class="footer-menu__icon" :class="{ 'footer-menu__icon_active': isOpen }">
        <use xlink:href="#svg-arrow-down"></use>
      </svg>
    </div>
    <SlideUpDown v-model="isOpen">
      <div class="footer-menu__items">
        <span v-if="screenWidth >= 992" class="footer-menu__title">
          {{ result?.title }}
        </span>

        <div v-for="item in result?.items">
          <div v-if="item?.isSovaClub">
            <SovaClubWrapper v-if="item?.showSovaClub">
              <template #name>{{ item.name }}</template>
            </SovaClubWrapper>
          </div>
          <a v-else :href="item.href" class="footer-menu__item">{{ item.name }}</a>
        </div>
      </div>
    </SlideUpDown>
  </section>
</template>

<script>
import SovaClubWrapper from '@components/SovaClub/SovaClubWrapper.vue';
import useScreenWidth from '@use/useScreenWidth';
import SlideUpDown from 'vue3-slide-up-down';

export default {
  name: 'FooterMenu',
  components: { SovaClubWrapper, SlideUpDown },
  props: ['result'],
  data() {
    return {
      open: false,
      screenWidth: useScreenWidth(),
    };
  },
  computed: {
    isOpen() {
      return this.open || this.screenWidth >= 992;
    },
  },
};
</script>

<style lang="scss" scoped>
.footer-menu {
  border-top: 1px solid rgba(255, 255, 255, 0.4);
  border-bottom: 1px solid rgba(255, 255, 255, 0.4);
  @include point-lg {
    border-top: unset;
    border-bottom: unset;
  }
  &__items {
    display: inline-grid;
    grid-row-gap: 12px;
    font-weight: 500;
    font-size: rem(16);
    line-height: 125%;
    padding-bottom: 16px;
    @include point-md {
      padding-bottom: 0;
    }
  }
  a {
    transition: 0.2s linear color;
    &:hover {
      color: var(--color-link-hover-dark);
    }
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 12px 0;
    font-size: 16px;
    font-weight: 700;
    line-height: 125%; /* 20px */
    text-transform: uppercase;
  }
  &__title {
    font-size: 18px;
    font-weight: 700;
    line-height: 125%; /* 22.5px */
    text-transform: uppercase;
  }

  &__icon {
    display: block;
    width: 20px;
    height: 20px;
    fill: currentColor;
    transition: 0.2s linear transform;

    &_active {
      transform: rotate(180deg);
    }
  }
}
</style>
